import React, { useState, useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import zoomInIcon from '../../../assets/icons/zoom-in.svg';
import zoomOutIcon from '../../../assets/icons/zoom-out.svg';
import locationcon from '../../../assets/icons/interface/gps-main.svg';

const ZoomControl = ({ bounds }) => {  // получаем bounds как пропс
    const map = useMap();
    const [position, setPosition] = useState(null);
    const [hasCentered, setHasCentered] = useState(false);

    // Функция обновления позиции
    const updatePosition = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    const latlng = [pos.coords.latitude, pos.coords.longitude];
                    setPosition(latlng);
                },
                (error) => {
                    console.error("Ошибка определения местоположения:", error);
                },
                { enableHighAccuracy: true, maximumAge: 0, timeout: 10000 }
            );
        } else {
            console.error("Геолокация не поддерживается вашим браузером.");
        }
    };

    // Обновление позиции каждые 3 секунды
    useEffect(() => {
        updatePosition(); // начальный вызов
        const intervalId = setInterval(updatePosition, 3000);
        return () => clearInterval(intervalId);
    }, []);

    // При первом получении координат центрируем карту только если позиция внутри bounds
    useEffect(() => {
        if (position && !hasCentered) {
            // Проверяем, входит ли позиция в границы
            if (bounds.contains(L.latLng(position[0], position[1]))) {
                map.setView(position, 18);
                setHasCentered(true);
            }
        }
    }, [position, hasCentered, map, bounds]);

    const zoomIn = () => {
        map.zoomIn();
    };

    const zoomOut = () => {
        map.zoomOut();
    };

    // Функция для кнопки "Вернуться к моему местоположению"
    const goToMyLocation = () => {
        if (position) {
            // Опционально можно добавить ту же проверку здесь
            if (bounds.contains(L.latLng(position[0], position[1]))) {
                map.setView(position, 18);
            } else {
                console.warn("Пользователь вне установленных границ");
            }
        } else {
            console.error("Позиция не определена");
        }
    };

    return (
        <div className="zoom-control">
            <button className="zoom-control-button" onClick={zoomIn} ><img src={zoomInIcon} alt="Увеличить"  width={18} height={18}/></button>
            <button className="zoom-control-button" onClick={zoomOut} ><img src={zoomOutIcon} alt="Уменьшить" width={18} height={18}/></button>
            <button className="zoom-control-button" onClick={goToMyLocation} ><img src={locationcon} alt="Моё местоположение" width={27} height={27}/></button>
        </div>
    );
};

export default ZoomControl;
